import { useState, useEffect, useRef, useCallback } from 'react'
import '../inquiry/telephonic/telephonic.scss'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../components/button/Button'
import { useNavigate } from 'react-router-dom'
import { permissions, ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import { FilterMatchMode, FilterService } from 'primereact/api'
import { TriStateCheckbox } from 'primereact/tristatecheckbox'
import ParentDataTable from '../../components/data-table/ParentDataTable'
import PopupBox from '../../components/popup/PopupBox'
import HorizontalLine from '../../assets/icons/Line33.svg'
import pencilicon from '../../assets/icons/pencil1.svg'
import '../course/viewCourseList.scss'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import './userManagement.scss'
import { dynamicCustomFilter } from '../../utility/genricFunction'
import { getAllUser } from '../../store/builders/userManagement/userManagement.builder'
import UseAuthorization from '../../utility/useAuthorization'
import Loader from '../../components/loader/Loader'

const UserManagement = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const roleSelector = useSelector((store) => store.auth)
  const userRole = roleSelector?.user?.result?.userData?.roleName
  const { allUsersData, loading } = useSelector((state) => state?.userManagement)
  const popupRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)


  const numbers = [
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
  ]
  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)

  const [filteredData, setFilteredData] = useState([])
  const [filterNumber] = useState(false)

  FilterService.register('dynamic_custom', (value, filter, filterMeta) => {
    return dynamicCustomFilter(value, filter, filterMeta?.matchMode || 'CONTAINS')
  })

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    userName: { value: null, matchMode: 'dynamic_custom' },
    userEmail: { value: null, matchMode: 'dynamic_custom' },
    userPhone: { value: null, matchMode: 'dynamic_custom' },
    roleName: { value: null, matchMode: 'dynamic_custom' },
  })

  // const handleArchive = () => setOpenArchive(true)

  useEffect(() => {
    dispatch(getAllUser())
    return () => dispatch({ type: 'user/clearExtraReducers' })
  }, [dispatch])


  const checkAllUserData = useCallback(() => {
    setFilteredData(allUsersData)
  }, [allUsersData])
  useEffect(() => {
    checkAllUserData()
  }, [allUsersData])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(allUsersData, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }


 
  const verifiedBodyTemplate = (allUsersData) => {
    const handleRowClick = (id) => {
      const path = ROUTES_PATH.USER_MANAGEMENT_EDIT.replace(':id', id)
      navigate(path)
    }
    return (
      <>
        <PopupBox rowData={allUsersData} setIsOpen={setIsOpen} isOpen={isOpen} popupRef={popupRef}>
          <div className='popupbox'>
            <p className='verifiedBodyTemplate-Assign'>{UI_CONSTANT.POP_UP_ACTION}</p>

          {UseAuthorization(permissions.EDIT_USER) && <>
            <img src={HorizontalLine} alt='' />
            <button
              className='div-assign-to-branch'
              onClick={() => handleRowClick(allUsersData.userId)}
            >
              <img src={pencilicon} alt='' />
              <p
                className={`${allUsersData?.branchStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Edit
              </p>
            </button>
          </>}

          </div>
        </PopupBox>
      </>
    )
  }

  const verifiedRowFilterTemplate = (options) => {
    return <TriStateCheckbox value={options.value} onChange={(e) => options.filterApplyCallback(e.value)} />
  }

  const columns = [
    {
      sortable: true,
      field: 'userName',
      header: 'User',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      // body: nameBody,
    },
    {
      sortable: true,
      field: 'userPhone',
      header: 'Phone',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by phone...',
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'userEmail',
      header: 'Email',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by email...',
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'roleName',
      header: 'Role',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by address...',
      style: { minWidth: '12rem' },
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
      filterElement: verifiedRowFilterTemplate,
    },
  ]

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.USER_MANAGEMENT.LABEL_USER_MANAGEMENT,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.USER_MANAGEMENT.LABEL_USER_MANAGEMENT,
      link: ROUTES_PATH.USER_MANAGEMENT,
    },
  ]

  return (
    <>
    {loading && <Loader loading={loading} />}

      { <Loader loading={loading} /> && <div className={`course-list }`}>
        <div className='filter-bar-wraper'>
          <div className='subheader'>
            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
              {UseAuthorization(permissions.ADD_USER) &&
              <Button
                className='add-btn'
                onClick={() => {
                  navigate('/user-management/add-user')
                }}
              >
                {UI_CONSTANT.USER_MANAGEMENT.ADD_USER}
              </Button>}
          </div>
        </div>

        <div className='group-parent'>
          <div className='frame-wrapper'>
            <div className='course-list-wrapper'>
              <b className='course-list1'>{UI_CONSTANT.USER_MANAGEMENT.ALL_USER}</b>
            </div>
          </div>
          <div className='flex page-drop-div'>
            <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
            <PageDropdown
              options={numbers}
              selectedValue={selectedNumber}
              onChange={(e) => setSelectedNumber(e.value)}
              className='w-full md:w-14rem small-dropdown'
            />
            <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
          </div>

          <div className={`table-card  ${userRole == UI_CONSTANT.ADMIN_ROLE ? 'action-btn-include' : ''}`}>
            <ParentDataTable
              value={filteredData}
              rows={filterNumber ? filteredData.length : selectedNumber}
              filters={filters}
              // loading={loading}
              columns={columns}
              onFilter={onFilter}
            />
          </div>
        </div>
      </div>}
    </>
  )
}

export default UserManagement
